var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cross_svg__path-1",
    d: "M24 2.4 21.6 0 12 9.6 2.4 0 0 2.4 9.6 12 0 21.6 2.4 24l9.6-9.6 9.6 9.6 2.4-2.4-9.6-9.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross_svg__icons-badges-variations",
    transform: "translate(-664 -234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross_svg__icons/cross",
    transform: "translate(664 234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross_svg__color/gray/70-4A4A4A"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cross_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cross_svg__path-1",
    id: "cross_svg__Mask",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cross_svg__color/black-tint/0-000000",
    fill: "#000",
    mask: "url(#cross_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cross_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  }))))))));
};
export default SvgCross;